import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { apiMethod } from './api-method';

function onBTDeviceFound() {
  MacleJSBridge.onBasicEvent(
    APINames.Native.ON_BLUETOOTH_DEVICE_FOUND,
    (params: any) => {
      apiMethod.emit(APINames.Native.ON_BLUETOOTH_DEVICE_FOUND, params);
    }
  );
}

function onScreenRecord() {
  MacleJSBridge.onBasicEvent(
    APINames.Native.ON_SCREEN_RECORD_STATE_CHANGE,
    (params: any) => {
      apiMethod.emit(APINames.Native.ON_SCREEN_RECORD_STATE_CHANGE, params);
    }
  );
}

function onKeyboardHeightChange() {
  MacleJSBridge.onBasicEvent(
    APINames.Native.ON_KEYBOARD_HEIGHT_CHANGE,
    (params: any) => {
      apiMethod.emit(APINames.Native.ON_KEYBOARD_HEIGHT_CHANGE, params);
    }
  );
}

export { onBTDeviceFound, onScreenRecord, onKeyboardHeightChange };
